// config/deportes.ts

export type Deporte = "Tenis" | "Padel" | "Futbol";

export interface ConfigDeporte {
  id: Deporte;
  nombre: string;
  icono: string;
  color: string;
  unidadPrincipal: string; // "sets" o "partido"
  unidadSecundaria: string; // "games" o "goles"
  permitirEmpates: boolean; // En fase de grupos
  permitirEmpatesEliminacion: boolean;
  minimosResultados: number; // Mínimo de sets/partidos para validar
  usaJugadores: boolean; // Si usa asignación de jugadores o solo nombres de equipo
  puntosVictoria: number;
  puntosEmpate: number;
  puntosDerrota: number;
}

export const DEPORTES_CONFIG: Record<Deporte, ConfigDeporte> = {
  Tenis: {
    id: "Tenis",
    nombre: "Tenis",
    icono: "mdi-tennis",
    color: "blue",
    unidadPrincipal: "Set",
    unidadSecundaria: "games",
    permitirEmpates: false,
    permitirEmpatesEliminacion: false,
    minimosResultados: 2, // Mínimo 2 sets
    usaJugadores: true,
    puntosVictoria: 3,
    puntosEmpate: 0,
    puntosDerrota: 0,
  },
  Padel: {
    id: "Padel",
    nombre: "Padel",
    icono: "mdi-tennis",
    color: "indigo",
    unidadPrincipal: "Set",
    unidadSecundaria: "games",
    permitirEmpates: false,
    permitirEmpatesEliminacion: false,
    minimosResultados: 2,
    usaJugadores: true,
    puntosVictoria: 3,
    puntosEmpate: 0,
    puntosDerrota: 0,
  },
  Futbol: {
    id: "Futbol",
    nombre: "Fútbol",
    icono: "mdi-soccer",
    color: "green",
    unidadPrincipal: "Partido",
    unidadSecundaria: "goles",
    permitirEmpates: true, // En fase de grupos SÍ
    permitirEmpatesEliminacion: false, // En eliminación NO (requiere definición)
    minimosResultados: 1, // Solo 1 partido
    usaJugadores: false, // Solo nombres de equipos
    puntosVictoria: 3,
    puntosEmpate: 1,
    puntosDerrota: 0,
  },
};

/**
 * Obtiene la configuración de un deporte
 */
export function getConfigDeporte(deporte: Deporte): ConfigDeporte {
  return DEPORTES_CONFIG[deporte] || DEPORTES_CONFIG.Tenis;
}

/**
 * Obtiene el ícono de un deporte
 */
export function getIconoDeporte(deporte: Deporte): string {
  return getConfigDeporte(deporte).icono;
}

/**
 * Obtiene el color de un deporte
 */
export function getColorDeporte(deporte: Deporte): string {
  return getConfigDeporte(deporte).color;
}

/**
 * Verifica si un deporte usa asignación de jugadores
 */
export function usaJugadores(deporte: Deporte): boolean {
  return getConfigDeporte(deporte).usaJugadores;
}

/**
 * Obtiene los puntos según resultado
 */
export function getPuntosPorResultado(
  deporte: Deporte,
  resultado: "victoria" | "empate" | "derrota"
): number {
  const config = getConfigDeporte(deporte);
  
  switch (resultado) {
    case "victoria":
      return config.puntosVictoria;
    case "empate":
      return config.puntosEmpate;
    case "derrota":
      return config.puntosDerrota;
    default:
      return 0;
  }
}